export const intlIdId = {
    测试: 'Tes',
    登录: 'Masuk',
    注册: 'Daftar',
    变量的例子: 'Contoh Variabel {value}',
    多样式多语言例子: '<span style="font-size: 12px;color: #d7cab3;">Contoh Variabel <span style="font-size: 16px;color: #fff;font-weight: 600;">@money</span></span>',
    体育: 'Pendidikan Jasmani',
    存款: 'Deposit',
    提款: 'Penarikan',
    请登录: 'Silakan masuk',
    余额刷新成功: 'Saldo berhasil diperbarui',
    我的金额: 'Uang saya',
    我的邀请码: 'Kode undangan saya',
    复制成功: 'Berhasil disalin',
    下一次抽奖: 'Undian berikutnya',
    您没有抽奖的机会: 'Anda tidak memiliki kesempatan undian',
    规则: 'Aturan',
    我的: 'Saya',
    我的信息: 'Informasi saya',
    资金详情: 'Detail dana',
    在线客服: 'Layanan pelanggan online',
    客服暂未配置: 'Layanan pelanggan belum dikonfigurasi',
    促销码: 'Kode promosi',
    请输入促销码: 'Silakan masukkan kode promosi',
    验证码: 'Kode verifikasi',
    请输入验证码: 'Silakan masukkan kode verifikasi',
    提交: 'Kirim',
    退出登录: 'Keluar',
    提示: 'Petunjuk',
    '确定要退出登录吗？': 'Apakah Anda yakin ingin keluar?',
    取消: 'Batal',
    确定: 'Konfirmasi',
    '升级到 {value} 还需要 {value}': 'Upgrade ke {value1} masih memerlukan {value2}',
    头像: 'Avatar',
    用户名: 'Nama pengguna',
    登录密码: 'Kata sandi masuk',
    提现密码: 'Kata sandi penarikan',
    修改提现密码: 'Ubah kata sandi penarikan',
    修改密码: 'Ubah kata sandi',
    设置提现密码: 'Atur kata sandi penarikan',
    请输入提现密码: 'Silakan masukkan kata sandi penarikan',
    请再次输入提现密码: 'Silakan masukkan kata sandi penarikan lagi',
    提现密码不能为空: 'Kata sandi penarikan tidak boleh kosong',
    确认提现密码不能为空: 'Konfirmasi kata sandi penarikan tidak boleh kosong',
    提现密码格式不正确: 'Format kata sandi penarikan tidak benar',
    确认提现密码格式不正确: 'Format konfirmasi kata sandi penarikan tidak benar',
    提现密码和确认提现密码不一致: 'Kata sandi penarikan dan konfirmasi kata sandi penarikan tidak sama',
    设置提现密码成功: 'Berhasil mengatur kata sandi penarikan',
    请输入旧密码: 'Silakan masukkan kata sandi lama',
    请输入新密码: 'Silakan masukkan kata sandi baru',
    请再次输入新密码: 'Silakan masukkan kata sandi baru lagi',
    旧密码不能为空: 'Kata sandi lama tidak boleh kosong',
    新密码不能为空: 'Kata sandi baru tidak boleh kosong',
    确认密码不能为空: 'Konfirmasi kata sandi tidak boleh kosong',
    '旧密码格式不正确, 请输入6-18位字母或数字': 'Format kata sandi lama tidak benar, silakan masukkan 6-18 karakter huruf atau angka',
    '新密码格式不正确, 请输入6-18位字母或数字': 'Format kata sandi baru tidak benar, silakan masukkan 6-18 karakter huruf atau angka',
    '确认密码格式不正确, 请输入6-18位字母或数字': 'Format konfirmasi kata sandi tidak benar, silakan masukkan 6-18 karakter huruf atau angka',
    新密码和确认密码不一致: 'Kata sandi baru dan konfirmasi kata sandi tidak sama',
    '修改密码成功, 请重新登录': 'Berhasil mengubah kata sandi, silakan masuk kembali',
    修改提现密码成功: 'Berhasil mengubah kata sandi penarikan',
    选择头像: 'Pilih avatar',
    今天: 'Hari ini',
    昨天: 'Kemarin',
    一个月内: 'Sebulan',
    余额: 'Saldo',
    编号: 'Nomor identifikasi',
    备注: 'Catatan',
    提现金额: 'Jumlah penarikan',
    充值: 'Isi ulang',
    账变: 'Perubahan akun',
    所有类型: 'Semua jenis',
    每天: 'Setiap hari',
    每周: 'Setiap minggu',
    每月: 'Setiap bulan',
    活动名称: 'Nama acara',
    优惠金额: 'Jumlah diskon',
    申请时间: 'Waktu aplikasi',
    '发放/审核时间': 'Waktu penerbitan/audit',
    状态: 'Status',
    活动奖项: 'Hadiah acara',
    排名: 'Peringkat',
    每日列表: 'Daftar harian',
    每周列表: 'Daftar mingguan',
    每月列表: 'Daftar bulanan',
    没有排名: 'Tidak ada peringkat',
    我的投注: 'Taruhanku',
    我的奖励: 'Hadiah saya',
    剩余排名: 'Peringkat tersisa',
    空缺: 'Kosong',
    奖励: 'Hadiah',
    总投注: 'Total taruhan',
    投注: 'Taruhan',
    '占所有玩家总投注额的 {value} %': 'Mengambil {value} % dari total taruhan semua pemain',
    暂无数据: 'Tidak ada data',
    首页: 'Beranda',
    优惠活动: 'Promosi',
    推广: 'Promosi',
    请选择: 'Silakan pilih',
    年: 'Tahun',
    月: 'Bulan',
    日: 'Hari',
    上午: 'Pagi',
    下午: 'Sore',
    天: 'Hari',
    周: 'Minggu',
    投注返利详情:
        '<span style="font-size: 10px;color: #d7cab3;">Jumlah total taruhan tim Anda adalah {value1}, dan Anda bisa mendapatkan hingga <span style="font-size: 14px;color: #fff;font-weight: 600;">{value2}</span> per bulan.</span>',
    优惠活动详情: 'Rincian promosi',
    活动申请: 'Aktivitas aplikasi',
    加载中: 'Memuat',
    申请: 'Terapkan',
    申请成功: 'Aplikasi berhasil',
    申请失败: 'Aplikasi gagal',
    所有记录: 'Semua catatan',
    申请中: 'Pendaftaran',
    发放成功: 'Penerbitan berhasil',
    审核失败: 'Peninjauan gagal',
    活动申请记录: 'Catatan aplikasi aktivitas',
    原因: 'Alasan',
    邮件: 'Email',
    邮件最多可保存30天: 'Email dapat disimpan hingga 30 hari',
    删除已读: 'Hapus Baca',
    全部接收: 'Terima semua',
    邮件详情: 'Detail email',
    删除: 'Hapus',
    确认密码: 'Konfirmasi kata sandi',
    真实姓名: 'Nama asli',
    姓: 'Nama belakang',
    名: 'Nama depan',
    邮箱: 'Email',
    邮箱验证码: 'Email kode verifikasi',
    发送: 'Kirim',
    手机号: 'Nomor ponsel',
    手机验证码: 'Kode verifikasi seluler',
    出生日期: 'Tanggal lahir',
    twitter: 'twitter',
    facebook: 'facebook',
    证件类型: 'Jenis ID',
    证件号: 'Nomor ID',
    推广码: 'Kode promosi',
    优惠码: 'kode penebusan',
    登录成功: 'Login berhasil',
    登录失败: 'Login gagal',
    登录账号: 'Login akun',
    请输入正确的邮箱: 'Silakan masukkan alamat email yang valid',
    请选择手机区号: 'Silakan pilih kode area seluler',
    手机号校验: 'Silakan masukkan a 6-12 digit nomor ponsel',
    请输入10位手机号: 'Silakan masukkan 10 digit nomor ponsel',
    验证码发送成功: 'Kode verifikasi berhasil terkirim',
    用户名验证: 'Nama pengguna harus diawali dengan (6-15) huruf dan kombinasi huruf kecil serta angka',
    用户名不能以test为起始: 'Nama pengguna tidak boleh diawali dengan tes',
    密码必须为6位数字: 'Kata sandi harus 6 digit',
    确认密码必须为6位数字: 'Konfirmasi kata sandi harus 6 digit',
    两次输入的密码不一致: 'Masukkan dua kali Kata sandi tidak cocok.',
    登录密码验证: 'Kata sandi harus kombinasi (6 hingga 18 karakter) huruf, angka atau karakter khusus',
    确认登录密码验证: 'Pastikan kata sandi harus berupa kombinasi (6 hingga 18 karakter) huruf, angka atau karakter khusus',
    请输入正确的姓名: 'Masukkan nama Anda yang benar',
    请输入出生日期: 'Masukkan tanggal lahir Anda',
    请输入您的twitter账号: 'Masukkan akun {value} Anda',
    请输入您的facebook账号: 'Silakan masukkan akun Facebook Anda',
    推广码校验: 'Konfirmasi bahwa Anda telah memasukkan kode promosi yang benar (1 hingga 8 digit)',
    推广码校验2: 'Masukkan kode promosi',
    请点击开始验证: 'Silakan klik Mulai Verifikasi',
    请输入邮箱验证码: 'Masukkan kode verifikasi email',
    请输入手机验证码: 'Masukkan kode verifikasi seluler',
    请输入姓: 'Masukkan nama belakang Anda',
    请输入名: 'Masukkan nama depan Anda',
    请输入证件号: 'Masukkan nomor ID Anda',
    请输入有效的CURP: 'Masukkan CURP yang valid',
    '请输入11~14位数字': 'Masukkan 11 hingga 14 digit',
    请选择证件类型: 'Silakan pilih jenis ID',
    请接受服务条款: 'Harap terima persyaratan layanan',
    邀请奖励: 'Undang Hadiah',
    问题1: 'Q1: Apa yang dimaksud dengan pembagian komisi?',
    回答1: 'A1: Setelah mengundang teman untuk bergabung dalam aplikasi dan mengikat kode undangan Anda, Anda akan menerima komisi tambahan berdasarkan konsumsi teman-teman tersebut dengan rasio tertentu. ',
    问题2: 'Q2: Apa yang dimaksud dengan klub?',
    回答2: 'A2: Klub Anda terdiri dari semua anggota tim agen Anda.',
    问题3: 'Q3: Bagaimana cara saya meningkatkan ke peringkat bintang klub yang lebih tinggi?',
    回答3: 'A3: Anda dapat meningkatkan dengan mengundang lebih banyak teman atau makan bersama dengan anggota tim. Untuk informasi lebih detail, silakan lihat tabel persyaratan peningkatan.',
    问题4: 'Q4: Bagaimana cara saya menerima hadiah?',
    回答4: 'A4: Setelah teman atau undangan teman Anda melakukan pembelian, Anda akan segera menerima semua hadiah, yang akan disetorkan ke akun komisi Anda dan dapat ditarik ke dompet Anda keesokan harinya.',
    问题5: 'Q5: Apakah ada persyaratan taruhan untuk menarik hadiah?',
    回答5: 'A5: Ada persyaratan taruhan satu kali.',
    问题6: 'Q6: Kapan saya dapat menggunakan hadiah saya?',
    回答6: 'A6: Anda dapat menarik hadiah Anda ke dompet Anda dompet untuk belanja keesokan harinya. Terkadang mungkin ada sedikit penundaan. Terima kasih atas pengertian Anda.',
    佣金比例详情: '※Anda dapat menerima persentase komisi tertentu dari semua taruhan dan jumlah isi ulang yang dilakukan oleh A, B, dan C. Silakan lihat diagram berikut untuk tarif komisi tertentu.',
    返利比例详情: '※Permainan yang berbeda memiliki rabat yang berbeda rasio. Anda juga dapat meningkatkan rasio rabat dengan meningkatkan peringkat bintang klub Anda.',
    立即邀请: 'Undang Sekarang!',
    佣金率: 'Tingkat komisi',
    流水返利: 'Rebate atas turnover',
    俱乐部之星: 'Bintang Klub',
    佣金等级: 'Komisi Lv{value}',
    首存返利: 'Rebate Deposit Pertama',
    什么是俱乐部: 'Apa itu klub?',
    俱乐部的星级越高介绍: 'Anda dan semua agen Anda membentuk klub Anda. Semakin tinggi peringkat bintang klub, semakin tinggi rasio rabat.',
    你的俱乐部: 'Klub Anda',
    如何提高俱乐部的星级: 'Bagaimana cara meningkatkan peringkat bintang klub?',
    代理要求: 'Persyaratan Agen',
    投注要求: 'Persyaratan Taruhan',
    无星: 'Tidak Ada Bintang',
    一星: 'Bintang Satu',
    二星: 'Bintang Dua',
    三星: 'Bintang Tiga',
    全部: 'Semua',
    我的奖金: 'Bonus saya',
    下一级: 'Level berikutnya',
    累计存款: 'Akumulasi Deposit {value}',
    每日提款限额: 'Batas Penarikan Harian',
    每日提现次数: 'Jumlah penarikan harian',
    每月累计存款升级VIP等级: 'Setoran Kumulatif Bulanan Peningkatan Level VIP',
    等级: 'Level',
    月度奖金: 'Bonus bulanan',
    等级升级奖励: 'Bonus peningkatan level',
    现金奖励发放时间: 'Bonus Tunai : Berdasarkan Anda Level VIP di akhir bulan ini, hadiah ini akan dikirimkan kepada Anda pada jam 10 pagi. pada tanggal 1 bulan depan.',
    晋级彩金: 'Upgrade Bonus',
    每月奖金: 'Bonus Bulanan',
    投注返水: 'Rebate Taruhan',
    网络问题: 'Masalah jaringan',
    '检测到您目前没有网络连接，请开启网络后再试。': 'Deteksi bahwa Anda saat ini tidak memiliki koneksi internet, silakan hidupkan internet Anda dan coba lagi.',
    设置: 'Pengaturan',
    总奖励: 'Total Hadiah',
    邀请总数: 'Total Undangan',
    邀请有效用户数量: 'Anda telah mengundang total {value1} teman, yang mana {value2} adalah pengguna yang valid.',
    邀请新客户获得: 'Undang pelanggan baru dapatkan',
    邀请好友可获得: 'Teman yang diundang dapatkan',
    邀请好友获取金钱: 'Undang teman untuk mendapatkan uang',
    每日邀请次数: 'Waktu undangan harian: {value}',
    邀请300位好友可获得: 'Undang {value} teman dapatkan',
    如何参与: 'CARA BERPARTISIPASI',
    步骤1: 'Langkah 1: Daftar',
    步骤2: 'Langkah 2: Klik halaman undangan mana pun untuk mengundang teman',
    步骤3: 'Langkah 3: Teman mendaftar dan masukkan kode undangan',
    步骤4: 'Langkah 4: Deposit teman {value}',
    步骤5: 'Langkah 5: Terima hadiah',
    什么是有效邀请用户: 'APA ITU PENGGUNA YANG DIUNDANG VALID?',
    有效邀请用户描述: 'Pengguna yang diundang secara valid adalah seseorang yang telah menyetorkan jumlah kumulatif yang lebih besar dari {value}',
    奖励兑换: 'REWARD REDEMPTION',
    奖励兑换步骤1: 'Untuk setiap undangan yang berhasil, pengundang menerima {value1}.',
    奖励兑换步骤2: 'Agen langsung (atasan pengundang) menerima bonus {value}.',
    奖励兑换步骤3: 'Agen atasan dari agen langsung menerima bonus {value}.',
    奖励兑换步骤4: 'Pengguna yang diundang juga menerima bonus {value}.',
    奖励兑换步骤5: 'Hadiah dapat digunakan untuk bermain game.',
    奖励兑换步骤6: 'Hadiah dibagikan secara otomatis oleh sistem.',
    活动解释权: '{value} memiliki hak penafsiran akhir untuk aktivitas ini.',
    '安装权限未被授予，无法打开APK文件': 'Izin instalasi tidak diberikan, tidak dapat membuka file APK',
    '权限已授予，正在尝试打开APK...': 'Izin telah diberikan, mencoba membuka APK...',
    立即更新: 'Perbarui Sekarang',
    稍后更新: 'Perbarui Nanti',
    版本号不符合规范: 'Nomor versi tidak sesuai dengan standar',
    邀请人数: 'Jumlah undangan',
    奖励详情: 'Detail hadiah',
    '网络错误, 请稍后重试!': 'Kesalahan jaringan, silakan coba lagi nanti!',
    存款金额: 'Jumlah setoran',
    奖励金额: 'Jumlah hadiah',
    立即存款: 'Setor Sekarang',
    今天不再显示: 'Jangan tampilkan lagi hari ini',
    倒计时: 'hitung mundur',
    应用未安装: 'Aplikasi tidak terinstal',
    邀请码: 'Kode undangan',
    请输入用户名: 'Silakan masukkan nama pengguna',
    密码: 'Kata sandi',
    请输入密码: 'Silakan masukkan kata sandi',
    '密码必须为(6~18位)字母或数字组合': 'Kata sandi harus berupa kombinasi huruf atau angka (6-18 karakter)',
    忘记密码: 'Lupa kata sandi',
    注册账号: 'Daftar akun',
    重置密码: 'Atur ulang kata sandi',
    '确定进入游戏吗?': 'Yakin masuk permainan?',
    进入游戏失败: 'Gagal masuk permainan',
    '确定要支付吗?': 'Apakah Anda yakin ingin membayar?',
    充值请求已取消: 'Permintaan top up dibatalkan',
    已提交充值请求: 'Permintaan top up telah diajukan',
    存款方式: 'Metode Setoran',
    存款账户: 'Akun Setoran',
    收款户名: 'Nama Penerima: ',
    银行账户: 'Akun Bank: ',
    开户地址: 'Alamat Cabang: ',
    开户银行: 'Bank Penerbit: ',
    单笔范围: 'Rentang Transaksi Tunggal: ',
    存款优惠: 'Promosi Setoran',
    最高奖金: 'Bonus Maksimal: ',
    剩余数量: 'Jumlah Tersisa: ',
    不选择: 'Tidak Pilih',
    请选择优惠: 'Silakan Pilih Promosi',
    充值优惠详情: 'Detail Promosi Top Up',
    详情: 'Detail',
    最小额: 'Min',
    最大额: 'Mak',
    存款提示: 'Tips Setoran',
    存款提示1: 'Setiap setoran akan masuk dalam 1-5 menit',
    存款提示2: 'Anda dapat menghubungi layanan pelanggan kapan saja untuk menyelesaikan masalah deposit',
    充值金额不能小于最小金额: 'Jumlah top up tidak boleh kurang dari jumlah minimal',
    立即支付: 'Bayar Sekarang',
    下一步: 'Langkah Selanjutnya',
    USDT数量: 'Jumlah USDT',
    充值金额: 'Jumlah Top Up',
    复制: 'Salin',
    TXID后五位: 'Lima Digit Terakhir TXID',
    汇款信息: 'Informasi Transfer',
    '(必填)请输入汇款人姓名或者卡号后四位': '(Wajib) Masukkan nama pengirim atau empat digit terakhir nomor kartu',
    上一步: 'Langkah Sebelumnya',
    备注信息不允许为空: 'Informasi catatan tidak boleh kosong',
    收款银行: 'Bank Penerima',
    银行地址: 'Alamat Bank',
    PIX类型: 'Jenis PIX',
    账号名称: 'Nama Akun',
    收款账户: 'Akun Penerima',
    PIX账号: 'Akun PIX',
    选择钱包类型: 'Pilih Jenis Dompet',
    '获取钱包列表失败, 请联系客服': 'Gagal mendapatkan daftar dompet, silakan hubungi layanan pelanggan',
    请选择钱包类型: 'Silakan Pilih Jenis Dompet',
    收款地址: 'Alamat Penerima',
    当前汇率: 'Kurs Saat Ini',
    转换金额: 'Jumlah Konversi',
    单日提现金额上限: 'Batas Penarikan Harian: ',
    单日提现次数上限: 'Batas Frekuensi Penarikan Harian: ',
    单笔最低提现额度: 'Jumlah Penarikan Minimum: ',
    单笔最高提现额度: 'Jumlah Penarikan Maksimum: ',
    提现时间段: 'Periode Penarikan: ',
    普通余额: 'Saldo Biasa: ',
    代理余额: 'Saldo Agen: ',
    普通余额可兑换USDT数量: 'Jumlah Saldo Biasa yang Dapat Ditukar USDT: ',
    代理余额可兑换USDT数量: 'Jumlah Saldo Agen yang Dapat Ditukar USDT: ',
    '你还没绑定三方钱包哦!': 'Anda belum mengikat dompet pihak ketiga!',
    选择钱包: 'Pilih Dompet',
    请输入提现金额: 'Masukkan Jumlah Penarikan',
    请输入有效金额: 'Masukkan Jumlah yang Valid',
    请输入正整数金额: 'Masukkan Jumlah Bilangan Bulat Positif',
    普通余额不足: 'Saldo Biasa Tidak Cukup',
    代理余额不足: 'Saldo Agen Tidak Cukup',
    请选择三方钱包: 'Silakan Pilih Dompet Pihak Ketiga',
    '你还没虚拟货币地址哦!': 'Anda belum memiliki alamat mata uang kripto!',
    请输入要兑换的USDT数量: 'Masukkan Jumlah USDT yang Akan Ditukar',
    请输入有效枚数: 'Masukkan Jumlah yang Valid',
    请输入正整数枚数: 'Masukkan Jumlah Bilangan Bulat Positif',
    提款数量不能大于可提款USDT数量: 'Jumlah penarikan tidak boleh lebih besar dari jumlah USDT yang dapat ditarik',
    请输入提款金额: 'Masukkan Jumlah Penarikan',
    请选择钱包: 'Silakan Pilih Dompet',
    '你还没绑定银行卡哦!': 'Anda belum mengikat kartu bank!',
    选择银行卡: 'Pilih Kartu Bank',
    请选择银行卡: 'Silakan Pilih Kartu Bank',
    '你还没绑定PIX哦!': 'Anda belum mengikat PIX!',
    选择PIX: 'Pilih PIX',
    请选择PIX类型: 'Silakan Pilih Jenis PIX',
    '你还没绑定支付宝哦!': 'Anda belum mengikat Alipay!',
    选择支付宝: 'Pilih Alipay',
    请选择支付宝: 'Silakan Pilih Alipay',
    去绑定: 'Mengikat',
    已选: 'Terpilih',
    兑换全部: 'Tukar Semua',
    当前提款不在时间段内: 'Penarikan saat ini di luar periode waktu',
    钱包中心: 'Pusat Dompet',
    绑卡提示: 'Pengguna yang terhormat, untuk keamanan informasi Anda, secara default hanya dapat mengikat {value} kartu, jika perlu dikecualikan atau diubah, silakan hubungi layanan pelanggan',
    钱包地址: 'Alamat Dompet',
    请输入钱包地址: 'Masukkan Alamat Dompet',
    请输入字母或数字: 'Masukkan Huruf atau Angka',
    钱包姓名: 'Nama Dompet',
    请输入钱包姓名: 'Masukkan Nama Dompet',
    持卡人姓名: 'Nama Pemegang Kartu',
    钱包名称: 'Nama Dompet',
    钱包账号: 'Akun Dompet',
    开户行地址: 'Alamat Bank Penerbit',
    钱包类型: 'Jenis Dompet',
    "TRC20需以字母'T'开头的34位字符": "TRC20 harus dimulai dengan huruf 'T' dan 34 karakter",
    银行卡类型: 'Jenis Kartu Bank',
    请选择银行卡类型: 'Silakan Pilih Jenis Kartu Bank',
    请输入开户行地址: 'Masukkan Alamat Bank Penerbit',
    已有银行卡号: 'Nomor Kartu Bank yang Ada',
    请输入已有银行卡号: 'Masukkan Nomor Kartu Bank yang Ada',
    银行卡账号: 'Akun Kartu Bank',
    请输入银行卡账号: 'Masukkan Akun Kartu Bank',
    请输入持卡人姓名: 'Masukkan Nama Pemegang Kartu',
    银行名称: 'Nama Bank',
    银行账号: 'Akun Bank',
    支付宝姓名: 'Nama Alipay',
    请输入支付宝姓名: 'Masukkan Nama Alipay',
    支付宝账号: 'Akun Alipay',
    请输入支付宝账号: 'Masukkan Akun Alipay',
    添加新账户: 'Tambah Akun Baru',
    资料信息提交成功: 'Informasi Data Berhasil Dikirim',
    联系地址: 'Alamat Kontak',
    请输入联系地址: 'Masukkan Alamat Kontak',
    完善信息: 'Mengisi Informasi',
    请先完善个人信息: 'Harap selesaikan informasi pribadi terlebih dahulu',
    请先选择优惠: 'Harap pilih diskon terlebih dahulu',
    请输入PIX账号: 'Masukkan Nomor PIX',
    活动金额: 'Jumlah Aktivitas',
    更换成功: 'Penggantian berhasil',
    注册成功: 'registrasi berhasil',
    注册失败: 'registrasi gagal',
    请选择线路: 'Silakan Pilih Jalur',
    '线路{value}': 'Jalur {value}',
    存款前请先绑定银行卡: 'Simpan sebelum mengikat kartu bank',
    额度回收: 'Kredit Dikembalikan',
    一键刷新: 'segarkan dengan satu klik',
    一键回收: 'daur ulang dengan satu klik',
    主平台金额: 'jumlah platform utama',
    我的团队俱乐部: 'Kelab Timku',
    俱乐部星级: 'Bintang Klub',
    俱乐部星级提示: 'Semakin tinggi peringkat bintang klub, semakin tinggi rasio rabat',
    俱乐部成员: 'Anggota Klub',
    俱乐部投注: 'Taruhan Klub',
    我的返佣: 'Komisi Saya:',
    投注返佣高达: 'Komisi Taruhan hingga',
    首次存款返佣: 'Komisi Deposit Pertama',
    可领取: 'Dapat Diterima',
    领取: 'Terima',
    领取成功: 'Berhasil Diterima',
    领取失败: 'Gagal Diterima',
    今日奖励: 'Hadiah Hari Ini',
    邀请朋友: 'Undang Teman',
    通过WhatsApp邀请: 'Undang melalui WhatsApp',
    保存图片: 'Simpan Gambar',
    分享: 'Bagikan',
    从属数据: 'Data Anak',
    总人数: 'Total Orang',
    本月: 'Bulan Ini',
    层级: 'Level',
    加入时间: 'Waktu Bergabung',
    佣金: 'Komisi',
    提款历史记录: 'Catatan Penarikan',
    邀请: 'Undang',
    邀请任务: 'Tugas Undang',
    时间: 'Waktu',
    佣金金额: 'Jumlah Komisi',
    成功: 'Berhasil',
    下级: 'Anak',
    受邀人数: 'Jumlah Orang yang Diundang',
    佣金总额: 'Total Komisi',
    提现公告: '{value1} berhasil menarik {value2}',
    个人资料: 'Profil',
    用户信息: 'Info Pengguna',
    昵称: 'Nama pengguna',
    今天1: 'Hari Ini',
    昨天1: 'Kemarin',
    奖励详情1: 'Detail hadiah',
    投注1: 'Taruhan',
    存款1: 'Deposit',
    状态1: 'Status',
    邀请奖励高达: 'Hadiah Undangan hingga',
    平台名称: 'Nama Platform',
    金额: 'Jumlah',
    刷新: 'Segarkan',
    回收: 'Daur ulang',
    休眠提示: 'Klik terlalu sering, silakan coba lagi setelah {value} detik',
    刷新成功: 'Segarkan Berhasil',
    刷新失败: 'Segarkan Gagal',
    回收成功: 'Daur ulang Berhasil',
    回收失败: 'Daur ulang Gagal',
    存款提示3: '1. Setiap deposit akan dikreditkan dalam waktu 1-5 menit.',
    存款提示4: '2. Anda dapat menghubungi layanan pelanggan kapan saja untuk menyelesaikan masalah deposit.',
    提款提示: 'Tips penarikan',
    提款提示1: 'Dalam keadaan normal, jumlah penarikan akan masuk ke akun Anda dalam waktu sekitar 2 jam, dan waktu terlama tidak akan melebihi 24 jam',
    钱包: 'Dompet',
    我的余额: 'Saldo Saya',
    绑定手机号: 'Nomor Telepon Terikat',
    绑定成功: 'Pengikatan berhasil',
    未绑定: 'Pembatalan',
    验证码发送失败: 'Pengiriman kode verifikasi gagal',
    投注记录: 'Catatan Taruhan',
    投注金额: 'Jumlah Taruhan',
    投注时间: 'Waktu Taruhan',
    订单号: 'Nomor Pesanan',
    平台: 'Platform',
    游戏名: 'Nama Permainan',
    玩法: 'Cara Bermain',
    投注模式: 'Mode Taruhan',
    有效投注: 'Taruhan Valid',
    盈亏金额: 'Jumlah Kemenangan/Kekalahan',
    '1、功能优化、性能优化': '1. Optimalisasi Fungsi, Optimalisasi Kinerja',
    '2、修复一些已知问题': '2. Perbaikan beberapa masalah yang diketahui',
    发现新版本: 'Versi Baru Ditemukan',
    奖励2: 'Hadiah',
    下一次免费旋转: 'Putaran Gratis Berikutnya',
    请输入正确的IFSC码: 'Masukkan kode IFSC yang benar',
    记录: 'Rekam',
    提款剩余时间: 'Waktu penarikan tersisa ',
    收集提现: 'Untuk menarik saat Anda mengumpulkan {value}',
    剩余提现额: '<span style="font-size: 13px;color: #ffffff;">hanya <span style="font-size: 13px;color: #e9b742;">{value}</span> yang bisa digunakan</span>',
    邀请好友获得免费旋转: 'Undang teman untuk mendapatkan Putaran Gratis',
    选择您的奖励: 'Pilih hadiah Anda',
    每日免费提款: 'Penarikan harian gratis',
    所有时间: 'Semua waktu',
    本周: 'Minggu ini',
    上周: 'Minggu lalu',
    QQ: 'QQ',
    微信: 'WeChat',
    telegram: 'telegram',
    whatsApp: 'whatsApp',
    line: 'line',
    instagram: 'Instagram',
    手机号格式不正确: 'Format nomor telepon salah',
    请输入真实姓名: 'Silakan masukkan nama asli',
    不限制: 'tidak ada batasan',
    请输入订单号: 'Silakan masukkan nomor pesanan',
    立即游戏: 'Mainkan sekarang',
    '存款 {value} 即可获得 {value} 次旋转。': 'Deposit {value1} untuk mendapatkan {value2} putaran',
    '1次': '{value} kali',
    历史: 'Riwayat',
    活动规则: 'Aturan aktivitas',
    游戏维护中: 'Game sedang dalam pemeliharaan',
    游戏维护时间: 'Game sedang dalam pemeliharaan,Waktu pemeliharaan: {value}',
    快捷登录: 'Masuk Cepat',
    绑定Google账号: 'Ikatan Akun Google',
    绑定失败: 'Ikatan Gagal',
    支持: 'Dukungan',
    更多: 'Lebih banyak',
    提现次数: '{value} kali',
    '请安装Google Play服务': 'Silakan instal Google Play Service',
    '暂无相册权限，请前往设置开启权限': 'Tidak ada izin album, silakan buka izin di pengaturan',
    '暂无相机权限，请前往设置开启权限': 'Tidak ada izin kamera, silakan buka izin di pengaturan',
    '暂无麦克风权限，请前往设置开启权限': 'Tidak ada izin mikrofon, silakan buka izin di pengaturan',
    '暂无手机存储权限，请前往设置开启权限': 'Tidak ada izin penyimpanan ponsel, silakan buka izin di pengaturan',
    请输入IFSC码: 'Silakan masukkan kode IFSC',
    搜索: 'mencari',
    恭喜你: 'Selamat',
    用户名或手机号码: 'nama pengguna atau nomor ponsel',
    请输入用户名或手机号码: 'Silakan masukkan nama pengguna atau nomor ponsel Anda',
    玩法说明: 'Petunjuk Permainan',
    截止时间: 'Waktu Berakhir',
    随机投注: 'Taruhan Acak',
    游戏记录: 'Catatan Permainan',
    图表趋势: 'Tren Grafik',
    我的投注记录: 'Catatan Taruhan Saya',
    期号: 'Nomor Periode',
    '大/小': 'Besar/Kecil',
    数字: 'Angka',
    颜色: 'Warna',
    大: 'Besar',
    小: 'Kecil',
    '投注助手（过去100期）': 'Asisten Taruhan (100 periode terakhir)',
    开奖号码: 'Nomor Undian',
    数量: 'Jumlah',
    我同意: 'Saya setuju',
    预售规则详情:
        '"Untuk melindungi hak dan kepentingan yang sah dari pengguna yang berpartisipasi dalam pra-penjualan dan menjaga ketertiban operasi normal, peraturan diterapkan sesuai dengan perjanjian dan peraturan yang relevan. 1.1 Definisi pra-penjualan: mengacu pada model penjualan di mana pedagang menyediakan solusi produk atau layanan, mengumpulkan pesanan konsumen melalui alat pra-penjualan produk, dan menyediakan barang atau layanan kepada konsumen sesuai dengan perjanjian sebelumnya. 1.2 Model pra-penjualan-penjualan adalah model ""deposit"". ""Deposit"" mengacu pada jumlah tetap dalam harga pra-penjualan komoditas yang dikirimkan di muka. ""Setoran"" dapat berpartisipasi dalam permainan mini dan memiliki kesempatan untuk memenangkan lebih banyak setoran. Deposit bisa langsung ditukar dengan merchandise. 1.3 Produk pra-penjualan: Mengacu pada produk yang dirilis oleh pedagang menggunakan alat produk pra-penjualan. Hanya tandai kata pra-penjualan pada judul produk atau halaman detail produk, dan produk yang tidak menggunakan alat pra-penjualan produk tidak diklasifikasikan sebagai produk pra-penjualan. 1.4 Sistem pra-penjualan: mengacu pada alat produk sistem yang disediakan untuk mendukung pedagang dalam penjualan model pra-penjualan - penjualan. 1.5 Harga produk pra-penjualan: mengacu pada harga penjualan produk pra-penjualan. Harga produk pra-penjualan terdiri dari dua bagian: deposit dan pembayaran akhir."',
    预售规则: 'Aturan Pra-penjualan',
    总金额: 'Jumlah Total',
    投注金额必须大于0: 'Jumlah taruhan harus lebih besar dari 0',
    请同意预售规则: 'Silakan setujui aturan pra-penjualan',
    投注小于最小限额: 'Taruhan kurang dari batas minimum',
    投注大于最大限额: 'Taruhan lebih besar dari batas maksimum',
    当前期已封盘: 'Periode saat ini sudah ditutup',
    请选择投注内容: 'Silakan pilih konten taruhan',
    投注失败: 'Taruhan gagal',
    投注成功: 'Taruhan berhasil',
    红色: 'Merah',
    绿色: 'Hijau',
    紫色: 'Ungu',
    购买金额: 'Jumlah Pembelian',
    购买数量: 'Jumlah Pembelian',
    税后金额: 'Jumlah Setelah Pajak',
    税收: 'Pajak',
    结果: 'Hasil',
    选择: 'Pilih',
    '输/赢': 'Kalah/Menang',
    创建时间: 'Waktu Pembuatan',
    'WIN GO彩票': 'WIN GO Lotere',
    'WIN GO规则详情':
        'Jika Anda membelanjakan 100 untuk berdagang, setelah dikurangi 2 biaya layanan, nilai kontrak Anda adalah 98:<br/><br/>1. Pilih hijau: Jika hasilnya menunjukkan 1,3,7,9, Anda akan mendapatkan (98*2) 196; Jika hasilnya menunjukkan 5, Anda akan mendapatkan (98*1.5) 147<br/><br/>2. Pilih warna merah: Jika hasilnya menunjukkan 2,4,6,8, Anda akan mendapatkan (98*2) 196; Jika hasilnya menunjukkan 0, Anda akan mendapatkan (98*1,5) 147<br/><br/>3. Pilih ungu: jika hasilnya menunjukkan 0 atau 5, Anda akan menerima (98*4.5) 441<br/><br/>4. Pilih nomor: Jika hasilnya sama dengan nomor yang dipilih, Anda akan menerima (98*9) 882<br/><br/>5. Pilih besar: Jika hasilnya menunjukkan 5,6,7,8,9 Anda akan mendapatkan (98*2) 196<br/><br/>6. Pilih kecil: Jika hasilnya menunjukkan 0,1,2,3,4, Anda akan mendapatkan (98 * 2) 196',
    该玩法不允许下注: 'Cara bermain ini tidak diizinkan untuk bertaruh',
    总赌注: 'Total Taruhan',
    赔率: 'Odds',
    选择3个唯一号码: 'Pilih 3 nomor unik',
    '*如果开盘号码与3个投注号码匹配，则中奖。': '*Jika nomor pembukaan cocok dengan 3 nomor taruhan, Anda menang.',
    '*如果开奖号码是相同号码中的任意三个，则中奖。': '*Jika nomor undian adalah tiga nom or yang sama, Anda menang.',
    '*如果开盘号码与2个投注号码匹配，则中奖。（三个相同的数字除外）。': '*Jika nomor pembukaan cocok dengan 2 nomor taruhan, Anda menang. (Kecuali tiga angka yang sama).',
    选择2个相同的数字: 'Pilih 2 angka yang sama',
    选择一对独特的数字: 'Pilih sepasang angka unik',
    '选择至少1对相同号码和1对不同号码进行投注，如果开盘号码与投注号码相符，则中奖。':
        'Pilih setidaknya 1 pasang nomor yang sama dan 1 pasang nomor yang berbeda untuk bertaruh, jika nomor pembukaan cocok dengan nomor taruhan, Anda menang.',
    选择2个不同的数字: 'Pilih 2 angka yang berbeda',
    选择3个不同的数字: 'Pilih 3 angka yang berbeda',
    '*选择3个或更多不同的数字。所抽中的3个号码若不同且符合选择，则中奖': '*Pilih 3 atau lebih angka yang berbeda. Jika 3 nomor yang diambil berbeda dan sesuai dengan pilihan, Anda menang',
    '*选择2个或更多不同的号码。 如果抽取的2个号码不同且符合选择，则中奖。': '*Pilih 2 atau lebih nomor yang berbeda. Jika 2 nomor yang diambil berbeda dan sesuai dengan pilihan, Anda menang.',
    '*若开奖号码为三个连续号码，则中奖。': '*Jika nomor undian adalah tiga nom or berurutan, Anda menang.',
    玩法提示1: 'Pilih 2 nomor yang sama. Jika hasil undian sesuai dengan pilihan anda, anda menang (kecuali 3 nomor yang sama).',
    玩法提示2: 'Pilih 2 nomor yang sama dan 1 nomor berbeda. Jika hasil undian sesuai dengan pilihan anda, anda menang.',
    玩法提示3: 'Pilih 3 nomor yang sama. Jika hasil undian sesuai dengan pilihan anda, anda menang.',
    玩法提示4: 'Pilih 3 angka yang sama. Jika hasil undian adalah tiga angka yang sama, Anda menang.',
    玩法提示5: 'Pilih 3 atau lebih nomor berbeda. Jika hasil undian cocok dengan pilihan Anda, Anda menang.',
    玩法提示6: 'Pilih 3 angka berturut-turut. Jika hasil undian adalah tiga angka berturut-turut, Anda menang.',
    玩法提示7: 'Pilih 2 atau lebih nomor berbeda. Jika hasil pengundian nomor berbeda dan cocok dengan nomor pilihan Anda, Anda menang.',
    K3彩票: 'K3 Lotere',
    K3规则详情:
        'Pengundian cepat 3 buah dadu untuk mendapatkan 3 angka pada setiap periodenya, angka dadu terdiri dari bilangan asli 111 sampai 666 (no 0), angka dadu tidak selalu berurutan, anda dapat menebak seluruh dadu atau sebagian dadu.<br/><br/>Nilai jumlah<br/>Menebak jumlah nilai numerik dari 3 dadu<br/><br/>3 angka yang sama<br/>Memasang taruhan pada 3 angka khusus yang sama (111, 222,…, 666).<br/><br/>2 angka yang sama<br/>Memasang taruhan pada 2 angka yang sama<br/><br/>2 nomor sama + 1 nomor berbeda<br/>Memasang taruhan pada 2 angka yang sama dan 1 angka yang berbeda<br/><br/>3 nomor berbeda<br/>Pasang taruhan pada 3 nomor berbeda<br/><br/>2 nomor berbeda<br/>Pasang taruhan pada 2 nomor berbeda<br/><br/>3 angka berurutan<br/>Memasang taruhan pada 3 angka berturut-turut<br/>(123, 234, 345, 456)<br/><br/>Kecil (3-11)<br/>Besar (12-18)',
    总和: 'Total',
    '奇/偶': 'Ganjil/Genap',
    '2个相同': '2 Sama',
    '3个相同': '3 Sama',
    '3个连续': '3 Berurutan',
    不同数字: 'Angka Berbeda',
    '5D彩票': '5D Lotere',
    '5D规则详情':
        'Menggambar instruksi<br/>5 digit angka (00000-99999) akan diambil secara acak pada setiap periode<br/>Misalnya:<br/>Nomor undian untuk Periode ini adalah 12345<br/>SEBUAH=1<br/>B=2<br/>C=3<br/>D=4<br/>E=5<br/>JUMLAH=A+B+C+D+E=15<br/>Cara bermain<br/>Pemain dapat menentukan enam hasil taruhan A, B, C, D, E dan jumlahnya<br/>A, B, C, D, E dapat dibeli<br/>Angka (0 1 2 3 4 5 6 7 8 9)<br/>Rendah (0 1 2 3 4)<br/>Ganjil (1 3 5 7 9)<br/>Tinggi (5 6 7 8 9)<br/>Ganjil (1 3 5 7 9)<br/>Genap (0 2 4 6 8)<br/>Jumlah = A+B+C+D+E dapat dibeli<br/>Rendah (0-22)<br/>Tinggi (23-45)<br/>Ganjil (1 3 ···43 45)<br/>Pasangan (0 2 ···42 44)',
    下拉即可刷新: 'Tarik ke bawah untuk menyegarkan',
    释放即可刷新: 'Lepaskan untuk menyegarkan',
    没有更多了: 'tidak lebih',
    试玩提示: 'Anda memasuki pengalaman uji coba; penarikan tidak tersedia setelah menghasilkan keuntungan',
    分享链接: 'bagikan tautan',
    应用已更新: 'Aplikasi telah diperbarui',
    点击确定重启App生效: 'Klik OK untuk memulai ulang aplikasi',
    热门: 'Populer',
    最近: 'Terbaru',
    收藏: 'Favorit',
    邀请好友帮忙提现: '1. Undang teman untuk membantu penarikan dana',
    向随机玩家发送邀请以提供帮助: '2. Kirim undangan ke pemain acak untuk membantu',
    通过短信发送消息: 'Kirim Pesan di ',
    短信: 'SMS',
    今天剩余提款额度: 'Sisa jumlah penarikan hari ini',
    VIP每日限额: 'Batas harian VIP',
    今天剩余提款次数: 'Jumlah sisa penarikan hari ini',
    VIP每日提款次数: 'Waktu penarikan harian VIP',
    单笔最小提款: 'Penarikan minimum tunggal',
    单笔最大提款: 'Penarikan tunggal maksimum',
    USDT地址: 'USDT alamat',
    今天提款次数已用完: 'Jumlah penarikan telah habis hari ini',
    提现提示: 'Kiat penarikan',
    系统异常: 'Pengecualian sistem',
    '你好，我们有一份礼物送给你': 'Hai, kami punya hadiah untuk Anda',
    请输入礼品代码: 'Silakan masukkan kode hadiah',
    奖金金额: 'Jumlah bonus: {value}',
    关注官方渠道获取代码: 'Ikuti saluran resmi untuk mendapatkan kode',
    '该金额暂无可用的充值通道,请更换充值金额': 'Tidak ada saluran isi ulang yang tersedia untuk jumlah ini. Silakan ubah jumlah isi ulang.',
    联系客服: 'Hubungi layanan pelanggan',
    上月: 'Bulan lalu',
    礼物: 'Hadiah',
    公链查询: 'Pencarian Rantai Publik',
    区块: 'Blok',
    区块时间: 'Waktu Block',
    哈希: 'Hash',
    trx详情:
        'Apa itu nilai hash?<br/><br/>Siapa pun yang mengetahui dasar-dasar Bitcoin akan diperkenalkan pada sebuah konsep, nilai hash. Header blok Bitcoin memiliki hash dari blok sebelumnya di dalamnya, yang digunakan untuk menunjuk ke blok sebelumnya.<br/><br/>Hash adalah transliterasi dari hash dalam bahasa Inggris, kita juga dapat menerjemahkannya menjadi hash, sehingga nilai hash juga disebut nilai hash. Nilai hash adalah nilai yang dihitung dengan fungsi hash (atau fungsi hash/algoritma hash). Untuk memahami nilai hash, seseorang harus memahami sifat fungsi hash. Fungsi hash secara komputasi dapat mengubah input dengan panjang yang berubah-ubah menjadi output dengan panjang yang tetap.<br/><br/>Setiap fungsi hash memiliki properti bahwa jika nilai inputnya sama, nilai hash outputnya juga sama. Jika nilai inputnya berbeda, hash outputnya biasanya berbeda, tetapi kemungkinan terjadinya tabrakan hash sangat kecil. Jika tabrakan hash dikesampingkan dengan sedikit perubahan pada nilai input, nilai hash yang sama sekali tidak terkait akan dikeluarkan. Karena fungsi hash tidak dapat dibalikkan dan mudah diverifikasi, hampir tidak mungkin untuk membalikkan nilai input melalui nilai hash output. Jika ada nilai input, nilai hash yang sesuai dapat diverifikasi segera.<br/><br/>Oleh karena itu, nilai hash setiap blok bersifat unik, acak, tidak dapat dipecahkan, tidak dapat dipalsukan, nilai hash blok diidentifikasi secara otomatis, dan catatan tidak dapat dirusak.<br/><br/>Ada berapa jenis USDT?<br/><br/>1. Omni-USDT berdasarkan jaringan Bitcoin, alamat deposit adalah alamat BTC, dan deposit dan penarikan melalui jaringan BTC;<br/><br/>2. ERC20-USDT berdasarkan protokol Ethereum ERC20, alamat deposit adalah alamat ETH, dan deposit dan penarikan melalui jaringan ETH;<br/><br/>3. TRC20-USDT berdasarkan protokol TRON TRC20 dan jaringan TRX (TRON), alamat penyetoran adalah alamat TRON, dan penyetoran dan penarikan dilakukan melalui jaringan TRON.<br/><br/>TrxHash adalah hash Blok TRC20-USDT berdasarkan protokol TRON TRC20 dan jaringan TRX (TRON). Angka terakhir digunakan sebagai hasil undian untuk menentukan apakah Anda telah memenangkan undian (klik Tinggi Blok untuk membuka rantai publik guna menanyakan hash Blok yang unik)<br/><br/>Aturan mainnya adalah sebagai berikut:<br/><br/>1. 1 undian lotere selama 1 menit, pembelian dalam waktu 45 detik, dan hasilnya tidak dapat dibeli dalam waktu 15 detik sebelum dibuka.<br/><br/>2. Pembelian Buka Kunci Sepanjang Hari. Jumlah total pembelian dalam satu hari adalah 1440.<br/><br/>3. Bahasa Indonesia: 3 poin 1 kali, 5 poin 1 kali, 10 poin 1 kali, aturannya sama dengan 1 poin 1 kali kecuali waktu pengundiannya berbeda.<br/><br/>4. Digit terakhir dari hash Blok digunakan sebagai hasil lotere:<br/><br/>Misalnya:<br/><br/>Jika nilai hash adalah **b569, hasil lotere adalah 9<br/><br/>Nilai hash **d14c, hasil lotere adalah 4<br/><br/>Jika Anda menghabiskan 100 untuk berdagang, setelah dikurangi biaya layanan 2%, jumlah kontrak: 98<br/><br/>l Pilih hijau: jika hasilnya menunjukkan 1,3,7,9, Anda akan mendapatkan (98 * 2) =196; jika hasilnya menunjukkan 5, Anda akan mendapatkan (98 * 2) = 196<br/><br/>l pilih merah: jika hasilnya menunjukkan 2,4,6,8, Anda akan mendapatkan (98 * 2) =196; jika hasilnya 0 maka akan mendapatkan (98 * 2) = 196<br/><br/>l pilih ungu: jika hasilnya 0 atau 5 maka akan mendapatkan (98 * 2) = 196<br/><br/>l pilih angka: jika hasil pembukaan sama dengan yang dipilih, akan mendapatkan (98 * 9) = 882<br/><br/>l pilih besar: jika hasilnya 5,6,7,8,9 maka akan mendapatkan (98 * 2) = 196<br/><br/>l pilih kecil: jika hasilnya 0,1,2,3,4 maka akan mendapatkan (98 * 2) = 196',
    'WIN TRX彩票': 'WIN TRX Lotere',
    确认进入游戏吗: 'Apakah Anda yakin untuk memasuki permainan?',
    奖励兑换码: 'Kode Hadiah',
    注册时间: 'Waktu Pendaftaran',
    '7 天全额存款': 'Deposit <span>{value}</span> hari penuh',
    何时可以领取奖金: 'Waktu untuk menarik hadiah',
    神秘奖金: 'Hadiah Misterius',
    活动已过期: 'Aktivitas sudah berakhir',
    已领取: 'Ditarik',
    首次存款: 'Deposit pertama',
    活动说明: 'Penjelasan aktivitas',
    等级优惠: 'Diskon Level',
    当前等级: 'Level saat ini',
    铁: 'Besi',
    青铜: 'Bạc',
    白银: 'Vàng',
    黄金: 'Bạch kim',
    铂金: 'Bạch kim',
    钻石: 'Kim cương',
    近7天游戏营业额: 'Doanh thu trò chơi gần đây {value} ngày',
    未达成: 'Belum memenuhi',
    已申请: 'Diterapkan',
    已收到: 'Diterima',
    保存: 'menyimpan',
    每周奖金: 'bonus mingguan',
    领取时间: 'Waktu pengumpulan',
    加载更多: 'Muat lebih banyak',
    游戏大厅: 'Lobi Permainan',
    更多游戏: 'More Games',
    底部描述:
        '{value} dioperasikan oleh {value2} dengan nomor registrasi perusahaan 142922, dengan alamat terdaftar di Zuikertuintjeweg Z/N (Zuikertuin Tower) Curacao dan dilisensikan serta disahkan oleh Pemerintah Curacao. {value} beroperasi di bawah Lisensi Utama Penyedia Layanan Permainan, N.V. Nomor Lisensi: GLH-OCCHKTW065752688',
    底部描述2:
        ' <p>1. Produk ini ditujukan untuk pengguna berusia 18 tahun ke atas dan ditujukan untuk tujuan hiburan saja.</p><p>2. Game ini berisi pembelian dalam aplikasi.</p><p>3. Fakta bahwa seorang pemain bermain atau menang dalam permainan judi sosial tidak berarti bahwa ia akan menang dalam perjudian dengan uang sungguhan dan permainan terkait di masa mendatang.</p>',
    版权声明: '{value} {value2}. Semua hak dilindungi undang-undang. 18+',
    支付成功: 'Pembayaran berhasil',
    最大掉落: '{value} pada suatu waktu Penurunan maksimal',
    每天几次: '{value} kali sehari',
    当前输赢: 'Kerugian saat ini',
    当前可领金额: 'Cantidad actual disponible',
    上一期输赢: 'Kerugian edisi terakhir',
    上一期可领金额: 'Cantidad disponible para el período anterior',
    赎回基金表: 'Tabla de fondos de rescate',
    比赛失败: 'El juego falló',
    赎回费用: 'tarifa de reembolso',
    救援金: 'dana bantuan',
    本周补偿: 'Kompensasi untuk minggu ini',
    本周盈利: 'Untung minggu ini',
    可获得补偿: 'Kompensasi tersedia',
    本周的补偿将分配到: 'Kompensasi minggu ini akan dibagikan kepada',
    每周报酬: 'Kompensasi Mingguan',
    补偿: 'Kompensasi',
    累计投注: 'Akumulasi taruhan',
    通过累积投注提升VIP等级: 'Tingkatkan level VIP dengan mengumpulkan taruhan',
    立即下载: 'Unduh sekarang',
    下载应用程序: 'Unduh aplikasi',
    您要下载并安装APP吗: 'Apakah Anda ingin mengunduh dan menginstal aplikasi?',
    暂无可用手机号: 'Belum ada nomor ponsel yang tersedia',
    '下载地址不存在，请稍后重试': 'Alamat unduhan tidak ada, silakan coba lagi nanti',
    '下载已开始，请在通知栏查看下载进度': 'Unduhan telah dimulai, silakan lihat proses unduhan di bilah notifikasi',
    '下载失败，请稍后重试': 'Unduhan gagal, silakan coba lagi nanti',
    支付倒计时: 'Silakan selesaikan pembayaran dalam {value}',
    支付方式: 'Metode pembayaran',
    钱包支付: 'Pembayaran dengan dompet',
    取消充值申请: 'Membatalkan permintaan deposit',
    查看充值记录: 'Lihat catatan deposit',
    打开App: 'Buka aplikasi {value}',
    每日游戏收入: 'Pendapatan permainan harian',
    签到奖金: 'Bonus masuk',
    手机号首位不能为0: 'Nomor telepon tidak boleh diawali dengan 0',
    真实姓名只能包含英文字母和空格: 'Nama sebenarnya hanya dapat berisi huruf dan spasi',
    请输入正确的银行卡账号: 'Silakan masukkan nomor rekening bank yang valid',
    请输入15位仅包含数字和字母的账号: 'Masukkan nomor rekening 15 karakter dengan huruf atau angka',
    请输入CLABE账号: 'Silakan masukkan akun CLABE',
    请输入正确的CLABE账号: 'Silakan masukkan akun CLABE yang valid',
    利息: 'Bunga',
    转入金额必须大于: 'Jumlah transfer harus lebih besar dari {value}',
    最小金额为: 'Minimum {value}, hanya bilangan bulat',
    已转入: 'Dimuat',
    年利率: 'Suku bunga tahunan {value}%',
    周期: `<span><span style="color: var(--profit-color-hover);">{value}</span> Siklus Resolusi (Maks. <span style="color: var(--profit-color-hover);"> {value2}</span>)</span>`,
    待处理: `<span> Tertunda <span style="color: var(--profit-text-warning);"> {value} </span> (Selesai {value2}) </span>`,
    收取: 'Terima',
    累计收益: 'Pendapatan Terakumulasi <span style="color: var(--profit-text-warning);"> {value}</span>',
    交易类型: 'Jenis Transaksi',
    奖金: 'Bonus',
    详细资料: 'Profil Detail',
    规则说明: 'Aturan Perawatan',
    解决周期: 'Siklus Resolusi',
    转账金额: 'Jumlah Transfer',
    当前时间: 'Waktu Saat Ini',
    存款利息结算: 'Setelah deposit ini, bunga pertama akan muncul pada {value}',
    确认转账: 'Konfirmasi Transfer',
    当前储蓄本: 'Buku Tabungan Saat Ini',
    转出金额: 'Jumlah yang Ditransfer',
    本次循环的倒计时: 'Waktu Hitung Mundur untuk Siklus Ini',
    提取利息提示: 'Setelah ditarik, Anda akan kehilangan bunga siklus ini!',
    确认提现: 'Konfirmasi Penarikan',
    转入: 'Transfer Masuk',
    账户余额: 'Saldo Akun',
    提款最小金额: 'Jumlah Penarikan Minimum {value}',
    提取金额必须大于: 'Jumlah penarikan harus lebih besar dari {value}',
    提取金额不能超过账户金额: 'Jumlah penarikan tidak boleh melebihi saldo akun',
    提取成功: 'Penarikan berhasil',
    提取失败: 'Penarikan gagal',
    转入成功: 'Transfer masuk berhasil',
    转入失败: 'Transfer masuk gagal',
    无限: 'Tidak terbatas',
    时: '{value} Jam',
    分: '{value} Menit',
    秒: '{value} Detik',
    利息宝未开启: '利息宝未开启',
    已完成: 'Selesai',
    处理中: 'Sedang diproses',
    已取消: 'Dibatalkan',
    已提交: 'Dikirim',
    审核中: 'Sedang diperiksa',
    出款中: 'Sedang ditarik',
    出款失败: 'Penarikan gagal',
    已审核: 'Diperiksa',
    补单成功: 'Pengembalian berhasil',
    补单失败: 'Pengembalian gagal',
    请输入UTR: 'Silakan masukkan UTR',
    请输入数字和字母: 'Silakan masukkan angka dan huruf',
    补单: 'Pengembalian',
    请输入12位数字: 'Silakan masukkan 12 digit angka',
    最多只能选择9个号码: 'Hanya dapat memilih hingga 9 nomor',
    请选择支付方式: 'Silakan pilih metode pembayaran',
    用户ID: 'ID pengguna/Nomor telepon',
    总余额: 'Saldo total',
    提现余额: 'Saldo yang dapat ditarik',
    请输入用户ID: 'Silakan masukkan ID pengguna/Nomor telepon',
    TelegramChannel: 'Saluran Telegram',
    真实姓名的长度不小于5个字符: 'Nama sebenarnya harus memiliki setidaknya 5 karakter',
    下载: 'Unduh',
    强度: 'Kekuatan',
    余额不足: 'Saldo tidak cukup',
    客服: 'Dukungan',
    有效投注总额: "Total Taruhan Valid",
    盈亏总额: "Total Untung dan Rugi",
    注册账户: 'Daftar akun',
    注册完成后可获得奖励: 'Setelah menyelesaikan pendaftaran, Anda dapat <span class="intro-highlight">mendapatkan {value}</span> hadiah',
    
    // Login pihak ketiga terkait
    第三方登录: 'Login Pihak Ketiga',
    登录方式: 'Login dengan',
    
    // Terkait pemuatan halaman callback
    '正在处理登录...': 'Memproses login...',
    '请稍候，即将为您跳转': 'Mohon tunggu, sedang mengarahkan...',
    赠送中心: 'Pusat Hadiah',
    截止日期: 'Tanggal Berakhir',
    返回顶部: 'Kembali ke atas',
    游戏: 'Permainan',
    搜索游戏: 'Cari permainan',
    下注成功: 'Taruhan berhasil',
    下注失败: 'Taruhan gagal',
    游戏历史: 'Riwayat permainan',
    期数: 'Periode',
    存款宝箱: 'Peti Harta Deposit',
    归回累存: 'Akumulasi deposit pengguna kembali',
    统计截至: 'Statistik per',
    剩余天数: 'Sisa hari',
    当前累计: 'Total akumulasi saat ini',
    距: 'Menuju',
    还差: 'Masih kurang',
    当前可领取: 'Saat ini dapat diklaim',
    档: 'Tingkat',
    累计门槛: 'Batas akumulasi',
    赠送金额: 'Jumlah bonus',
    打码: 'Persyaratan taruhan',
    可提前领取: 'Dapat diklaim lebih awal. Setelah diklaim, tingkat yang lebih tinggi tidak dapat dicapai',
    活动进行中: 'Acara sedang berlangsung',
    活动到期领取: 'Acara sedang berlangsung. Hadiah dapat diklaim setelah acara berakhir',
    第几天: 'Hari ke-{value}',
    已于第几天领取: '<strong>{value1}</strong> diklaim pada hari ke-{value}',
    几天: '{value} hari',
    回归每日首存: 'Deposit pertama harian pengguna kembali',
    今日时间: 'Waktu hari ini',
    今日首笔存款: 'Deposit pertama hari ini',
    可用奖金: 'Bonus tersedia',
    奖金比例: 'Persentase bonus',
    立即领取: 'Klaim sekarang',
    去充值: 'Deposit',
    查看活动: 'Lihat acara',
    再充值一点更划算: 'Deposit sedikit lagi untuk hadiah yang lebih besar',
    当前档: 'Tingkat saat ini',
    冲刺档: 'Tingkat target',
    冲: 'Tambah',
    直接领取当前奖励: 'Klaim {value} sekarang',
    活动结束: 'Acara berakhir',
    恭喜领取成功: 'Hadiah berhasil diklaim',
    累计奖励已入账户: 'Hadiah akumulasi {value} telah masuk ke akun',
    请完成打码流水后提现: 'Selesaikan persyaratan taruhan sebelum menarik dana',
    知道了: 'Mengerti',
    去下注: 'Pasang taruhan',
    充值后最高赠送: 'Bonus maksimum setelah deposit: {value}',
    倍数: 'Kelipatan',
    必须通过此页面充值才能获得多倍奖金: 'Anda harus melakukan deposit melalui halaman ini untuk mendapatkan bonus kelipatan',
    已领取宝箱金额: 'Hadiah peti telah diterima',
    已领取翻倍奖励: 'Bonus {value}x telah diterima',
    充值领取最高: 'Deposit untuk menerima hingga {multiple}x, hadiah {value}',
    说明: 'Keterangan',
    翻倍充值说明: 'Petunjuk Deposit Kelipatan',
    参与活动: 'Ikuti acara',
    领取额外奖励: 'Klaim hadiah tambahan',
    开始时间: 'Waktu mulai',
    流水倍数: 'Kelipatan taruhan',
    打开: 'Buka',
    继续领取: 'Lanjutkan klaim',
    翻倍领取: 'Klaim bonus kelipatan',
};
